import { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { rtdb as db } from "../lib/firebaseClient";     // uses the same singleton you made

export default function TotalGamesPlayed() {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    // First try /stats/totalGamesPlayed for global counter
    const statsRef = ref(db, "/stats/totalGamesPlayed");
    const playersRef = ref(db, "/players");

    let playersUnsub = null;

    // Try global stats counter first
    const statsUnsub = onValue(
      statsRef,
      (snap) => {
        const globalTotal = snap.val();
        if (typeof globalTotal === "number" && globalTotal > 0) {
          setTotal(globalTotal);
        } else {
          // Fallback: sum from /players (tournament server data)
          playersUnsub = onValue(
            playersRef,
            (playerSnap) => {
              const data = playerSnap.val() || {};
              let sum = 0;
              for (const u of Object.values(data)) {
                const v =
                  (typeof u?.totalGamesPlayed === "number" && u.totalGamesPlayed) ||
                  (typeof u?.gamesPlayed === "number" && u.gamesPlayed) ||
                  0;
                sum += v;
              }
              setTotal(sum);
            },
            (err) => {
              console.error("TotalGamesPlayed (players):", err);
              setTotal(0);
            }
          );
        }
      },
      (err) => {
        console.error("TotalGamesPlayed (stats):", err);
        // Try fallback on error too
        playersUnsub = onValue(
          playersRef,
          (playerSnap) => {
            const data = playerSnap.val() || {};
            let sum = 0;
            for (const u of Object.values(data)) {
              const v =
                (typeof u?.totalGamesPlayed === "number" && u.totalGamesPlayed) ||
                (typeof u?.gamesPlayed === "number" && u.gamesPlayed) ||
                0;
              sum += v;
            }
            setTotal(sum);
          },
          () => setTotal(0)
        );
      }
    );

    return () => {
      statsUnsub();
      if (playersUnsub) playersUnsub();
    };
  }, []);

  return <>{total == null ? "—" : total.toLocaleString()}</>;
}
